import {
  Component, OnInit, ViewChild, ElementRef, Inject, ViewEncapsulation, ChangeDetectorRef,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators, AbstractControl, FormGroupDirective, } from "@angular/forms";
import { LoginService } from "src/app/services/login.service";
import { HttpErrorResponse, HttpClient } from "@angular/common/http";
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar, MatDialog, } from "@angular/material";
import { HeaderComponent } from "../header/header.component";
import { Router } from "@angular/router";
import { AuthService, FacebookLoginProvider, SocialUser, GoogleLoginProvider, } from "angularx-social-login";
import { PushMessagingService } from "src/app/services/push-messaging.service";
import { JobsService } from "src/app/services/jobs.service";
import { PrefferedListComponent } from "../preffered-list/preffered-list.component";
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/services/language.service';
import { VerifyOtpComponent } from "../verify-otp/verify-otp.component";
import { UserServiceService } from "src/app/services/user-service.service";

@Component({
  selector: "app-sign-up",
  templateUrl: "./sign-up.component.html",
  styleUrls: ["./sign-up.component.css"],
})
export class SignUpComponent implements OnInit {
  customerSignUpForm: FormGroup;
  verificationForm: FormGroup;
  socialLoginForm: FormGroup;
  setProfileForm: FormGroup;
  showProfileForm: boolean = false;
  tabIndex: number = 0;
  confirmPassword: boolean = false;
  showLoginForm: boolean = true;
  token: any;
  isRefferalSignUp: boolean = false;
  refferalObj: any = {};
  user: SocialUser;
  lat: number = 3.09121;
  lang: number = 101.677101;
  loading: boolean = false;
  serverOtp: any;
  @ViewChild("fileInput", { static: true }) el: ElementRef;
  previewUrl: any = "https://india-live-api.talentasker.com/user.png";
  @ViewChild("mtg", { static: true }) mtg: ElementRef;
  heading: string = "Create Your Account";
  userId: string;
  formatedAddress = "";
  checkError: boolean = false;
  isSuggestionsSelected: boolean = false;
  isWorkerSelected: boolean = true;
  selectedCat: Array<any> = [];
  maxDate: any;
  minDate: any;
  hide = true;
  hide2 = true;
  options = {
    componentRestrictions: {
      country: ["IN"],
    },
  };
  acceptTask: boolean = false;
  selectedLanguage: string;
  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private loginService: LoginService,
    private dialogRef: MatDialogRef<HeaderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cd: ChangeDetectorRef,
    private router: Router,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    private pushMessageService: PushMessagingService,
    private jobService: JobsService,
    private translateService: TranslateService,
    private languageService: LanguageService,
    private userService: UserServiceService
  ) {
    this.loginService.setUserId.subscribe((val) => {
      if (val == true) {
        this.setUserId();
      }
    });
    this.languageService.selectedLanguage$.subscribe(language => {
      this.selectedLanguage = language;
    });
  }

  ngOnInit() {
    this.refferalObj = JSON.parse(localStorage.getItem("refferal"));
    if (this.refferalObj && this.refferalObj.invitedby) {
      this.isRefferalSignUp = true;
    } else {
      this.isRefferalSignUp = false;
    }
    let eighteenYearsFromNow = new Date();
    this.maxDate = new Date(
      eighteenYearsFromNow.setFullYear(eighteenYearsFromNow.getFullYear() - 18)
    );
    this.minDate = new Date(
      eighteenYearsFromNow.setFullYear(eighteenYearsFromNow.getFullYear() - 82)
    );
    this.customerSignUpForm = this.fb.group(
      {
        // userID: ["", [Validators.required, Validators.email]],
        userID: ["", [Validators.required]],
        password: ["", [Validators.required, Validators.minLength(8)]],
        confirmPassword: ["", Validators.required],
        register_type: ["Manual"],
        isCheck: ["", Validators.required],
      },
      {
        validators: this.passwordConfirming,
      }
    );

    this.setProfileForm = this.fb.group({
      profilePic: ["", Validators.required],
      userID: [""],
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      latitude: ["", Validators.required],
      longitude: ["", Validators.required],
      phoneNumber: ["", [Validators.required, Validators.email]],
      address: ["", Validators.required],
      postTask: [true],
      completeTask: [true],
      deviceToken: [""],
      deviceType: ["web"],
      dob: ["", Validators.required],
    });
    this.verificationForm = this.fb.group({
      userID: [""],
      otp: ["", [Validators.required]],
    });
    this.http
      .get(this.previewUrl, { responseType: "blob" })
      .subscribe((file) => {
        let imgFile = new File([file], "userImg.jpg");
        this.setProfileForm.get("profilePic").setValue(imgFile);
      });
    // social Media login
    this.socialLoginForm = this.fb.group({
      ID: [""],
      userID: [""],
      firstName: [""],
      lastName: [""],
      register_type: [""],
      latitude: [""],
      longitude: [""],
      tokenID: [""],
      profilePic: [""],
      deviceToken: [""],
      deviceType: ["web"],
    });

    this.authService.authState.subscribe((user) => {
      this.user = user;
      if (this.user != null) {
        //this.dialogRef.close(this.user)
        this.loading = false;
        this.pathchSocialLoginDetails(this.user);
        console.log(this.user)
        this.logout();
      } else {
        this.loading = false;
      }
    });
    let id = localStorage.getItem("userId");
    if (id != null) {
      this.customerSignUpForm.patchValue({
        userID: id,
      });
      localStorage.removeItem("userId");
    }
    this.switchLanguage(this.selectedLanguage);
  }
  switchLanguage(languageCode: string): void {
    this.translateService.use(languageCode);
  }

  setUserId() { }
  logout() {
    this.authService.signOut().then((data) => {
    });
  }
  getLatLang() {
    this.loginService.getPosition().then((pos) => {
      this.lat = pos.lat;
      this.lang = pos.lng;
    });
  }

  pathchSocialLoginDetails(user) {
    this.loading = true;
    let providerType = user.provider.toLowerCase();
    let pType = providerType.charAt(0).toUpperCase() + providerType.slice(1);
    this.socialLoginForm.patchValue({
      ID: user.id,
      userID: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      register_type: pType,
      latitude: this.lat,
      longitude: this.lang,
      tokenID: user.authToken,
      profilePic: user.photoUrl,
    });
    if (!user.email) {
      const txtmsg = this.translateService.instant("This social media dont have email details");
      this.openSnackBar(txtmsg, '');
      return;
    }
    let obj = { userID: user.email };
    this.loginService.checkUserAvailability(obj).subscribe(
      (res) => {
        if (res.isActive) {
          this.submitSocialMedia();
        } else {
          const txtmsg = res.message;
          const txtmsg2 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg2, '');
        }
      },
      (err: HttpErrorResponse) => {
        const txtmsg = err.message.trim();
        const txtmsg12 = this.translateService.instant(txtmsg);
        this.openSnackBar(txtmsg12, '');
        if (err.error instanceof Error) {
          console.log("Client Side Error", err.headers);
        } else {
          console.log("Server side Error", err.message);
        }
      }
    );
  }
  submitSocialMedia() {
    let payLoad = { ...this.socialLoginForm.value };
    if (this.isRefferalSignUp) {
      payLoad.signupReferralBy = this.refferalObj.invitedby;
    }
    this.loginService.socialLogin(payLoad).subscribe(
      (posRes) => {
        if (posRes.response == 3) {
          this.loginService.isSocilaLogin = true;
          this.loading = false;
          localStorage.setItem("token", posRes.tokenID);
          if (posRes.customerInfo) {
            this.dialogRef.close(posRes);
          } else {
            this.dialogRef.close(this.socialLoginForm.value);
          }
        }
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        // this.openSnackBar(err.message, "");
        const txtmsg = err.message.trim();
        const txtmsg25 = this.translateService.instant(txtmsg);
        this.openSnackBar(txtmsg25, '');
        if (err.error instanceof Error) {
          console.log("Cse", err.message);
        } else {
          console.log("SSE", err.message);
        }
      }
    );
  }
  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }
  signInWithFB(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }
  //message alerts showing
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
      panelClass: "red-snackbar",
      verticalPosition: "top",
    });
  }
  onBlurMethod() {
    let str = this.setProfileForm.get("address").value;
    this.formatedAddress = str;
    this.jobService.getLat(str.replace(/\g/, "+")).subscribe(
      (res) => {
        if (!this.isSuggestionsSelected) {
          if (
            res &&
            res.results.length &&
            res.results[0].geometry &&
            res.results[0].geometry.location
          ) {
            this.setProfileForm.patchValue({
              latitude: "" + res.results[0].geometry.location.lat,
              longitude: "" + res.results[0].geometry.location.lng,
            });
          } else {
            this.setProfileForm.patchValue({
              latitude: "",
              longitude: "",
            });
          }
        } else {
          this.isSuggestionsSelected = false;
        }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.warn("Client Error", err.message);
        } else {
          console.warn("Server Error", err.message);
        }
      }
    );
  }
  public handleAddressChange(address: any) {
    this.isSuggestionsSelected = true;
    this.formatedAddress = address.formatted_address;
    this.setProfileForm.get("address").setValue(this.formatedAddress);
    let lat = address.geometry.location.lat();
    let lang = address.geometry.location.lng();
    this.setProfileForm.patchValue({
      latitude: "" + lat,
      longitude: "" + lang,
    });
  }

  passwordConfirming(c: AbstractControl) {
    if (c.get("password").value !== c.get("confirmPassword").value) {
      c.get("confirmPassword").setErrors({ NoPassswordMatch: true });
    }
    return null;
  }
  resendOtp() {
    this.sendDetails();
  }
  checkAvailability() {
    if (
      this.customerSignUpForm.valid &&
      this.customerSignUpForm.value.isCheck == true
    ) {
      let payload = { ...this.customerSignUpForm.value };
      let obj = { userID: payload.userID };
      console.log(obj);
      this.loginService.checkUserAvailability(obj).subscribe(
        (res) => {
          if (res.isActive) {
            this.sendDetails();
          } else {
            const txtmsg = res.message;
            const txtmsg2 = this.translateService.instant(txtmsg);
            this.openSnackBar(txtmsg2, '');
          }
        },
        (err: HttpErrorResponse) => {
          const txtmsg = err.message.trim();
          const txtmsg1 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg1, '');
          if (err.error instanceof Error) {
            console.log("Client Side Error", err.headers);
          } else {
            console.log("Server side Error", err.message);
          }
        }
      );
    } else {
      if (this.customerSignUpForm.value.isCheck == false) {
        this.checkError = true;
      }
    }
  }
  sendDetails() {
    if (
      this.customerSignUpForm.valid &&
      this.customerSignUpForm.value.isCheck == true
    ) {
      this.checkError = false;
      this.loading = true;
      let payLoad = { ...this.customerSignUpForm.value };
      delete payLoad.confirmPassword;
      delete payLoad.isCheck;
      if (this.isRefferalSignUp) {
        payLoad.signupReferralBy = this.refferalObj.referralCode;
      }
      this.sendMoibieOtp(payLoad);

    } else {
      if (this.customerSignUpForm.value.isCheck == false) {
        this.checkError = true;
      }
    }
  }
  numericOnly(event) {
    let patt = /^([0-9])$/;
    let result = patt.test(event.key);
    return result;
  }

  sendMoibieOtp(data) {
    let payload = {
      phoneNumber: data.userID,
      userID: data.userID,
      dialCode: "+91",
    };
    console.log("manualpy", payload)
    let dialogRef = this.dialog.open(VerifyOtpComponent, {
      panelClass: "col-md-4",
      hasBackdrop: true,
      disableClose: true,
      data: payload,
    });
    dialogRef.afterClosed().subscribe((val) => {
      if (val) {
        let payLoad = { ...this.customerSignUpForm.value };
        delete payLoad.confirmPassword;
        delete payLoad.isCheck;
        payLoad["phoneNumber"] = payLoad.userID;
        payLoad["dialCode"] = "+91";
        payLoad["countryCode"] = "IN"
        console.log(payLoad);
        this.loginService.customerSignup(payLoad).subscribe(
          (posRes) => {
            if (posRes.response === 3) {
              this.loading = false;
              const txtmsg = posRes.message;
              const txtmsg1 = this.translateService.instant(txtmsg);
              this.openSnackBar(txtmsg1, '');
              localStorage.setItem("token", posRes.tokenID);
              this.token = posRes.tokenID;
              // localStorage.setItem("user", JSON.stringify(posRes.customerInfo));
              this.showLoginForm = false;
              this.showProfileForm = true;
              this.confirmPassword = false;
              this.heading = "Profile";
              this.setProfileForm.patchValue({
                userID: this.customerSignUpForm.value.userID,
              });
            } else {
              this.loading = false;
              const txtmsg = posRes.message;
              const txtmsg1 = this.translateService.instant(txtmsg);
              this.openSnackBar(txtmsg1, '');
              this.showProfileForm = false;
            }
          },
          (err: HttpErrorResponse) => {
            this.loading = false;
            if (err.error instanceof Error) {
              console.log("Client Side Error", err.headers);
            } else {
              console.log("Server side Error", err.message);
            }
          }
        );

      } else {
        this.loading = false;
      }
    })
  }

  fileProgress(event) {
    let reader = new FileReader();
    let file = event.target.files[0];
    if (event.target.files && event.target.files[0]) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.previewUrl = reader.result;
        this.setProfileForm.get("profilePic").setValue(file);
      };
      this.cd.markForCheck();
    }
  }

  removeUploadedFile() {
    let newFileList = Array.from(this.el.nativeElement.files);
    this.previewUrl = "../../../assets/add-profile.png";
    this.setProfileForm.get("profilePic").setValue(null);
  }
  openCategories() {
    let dailogRef = this.dialog.open(PrefferedListComponent, {
      panelClass: "col-md-3",
      hasBackdrop: true,
      disableClose: true,
      data: this.selectedCat,
    });
    dailogRef.afterClosed().subscribe((res) => {
      if (res.length) {
        this.selectedCat = [...res];
      } else {
      }
    });
  }
  onWorkerSelected(event) {
    this.isWorkerSelected = event.checked;
    if (!event.checked) {
      this.selectedCat = [];
    }
  }
  submitProfile() {
    if (
      this.setProfileForm.value.postTask == true ||
      this.setProfileForm.value.completeTask == true
    ) {
      if (this.setProfileForm.value.completeTask == true) {
        if (!this.selectedCat.length) {
          const txtmsg1 = this.translateService.instant("Select atleast one Prefered Task Category");
          this.openSnackBar(txtmsg1, '');
          return;
        }
      }
      if (this.setProfileForm.get("latitude").valid) {
        this.loading = true;
        let deviceID = this.pushMessageService.fcmToken;
        if (deviceID != null) {
          this.setProfileForm.patchValue({
            deviceToken: this.pushMessageService.fcmToken,
          });
        }
        this.setProfileForm.patchValue({
          userID: this.customerSignUpForm.value.userID,
          completeTask: "" + this.setProfileForm.value.completeTask,
          postTask: "" + this.setProfileForm.value.postTask,
        });
        let formData = new FormData();
        formData.append(
          "profilePic",
          this.setProfileForm.get("profilePic").value
        );
        let payLoad = { ...this.setProfileForm.value };
        payLoad.dob = new Date(payLoad.dob).toLocaleDateString();
        payLoad.phoneNumber = payLoad.phoneNumber;
        payLoad.category = this.selectedCat;
        console.log(payLoad)
        delete payLoad.profilePic;
        formData.append("profileInfo", JSON.stringify(payLoad));
        this.loginService.setProfile(formData, this.token).subscribe(
          (posRes) => {
            if (posRes.response == 3) {
              this.loading = false;
              const txtmsg = posRes.message;
              const txtmsg1 = this.translateService.instant(txtmsg);
              this.openSnackBar(txtmsg1, '');;
              localStorage.setItem("user", JSON.stringify(posRes.customerInfo));
              // this.userService.isFetchUser.next(true);
              this.dialogRef.close(posRes);
            } else {
              this.loading = false;
              const txtmsg = posRes.message;
              const txtmsg1 = this.translateService.instant(txtmsg);
              this.openSnackBar(txtmsg1, '');;
            }
          },
          (err) => {
            this.loading = false;
          }
        );
      } else {
        const txtmsg4 = this.translateService.instant("Enter Valid Address...");
        this.openSnackBar(txtmsg4, '');
      }
    }
  }
  closeTab() {
    if (this.isRefferalSignUp) {
      localStorage.removeItem("refferal");
    }
    this.dialogRef.close();
  }
  submit() {
    this.showProfileForm = true;
  }
  openLogin() {
    this.dialogRef.close();
    this.loginService.callLogin.next(true);
  }

  sendOtp() {
    this.loading = true;
    this.verificationForm.patchValue({
      userID: this.customerSignUpForm.value.userID,
    });
    this.loginService.verify(this.verificationForm.value).subscribe(
      (posRes) => {
        if (posRes.response == 3) {
          this.loading = false;
          this.heading = "Profile";
          localStorage.setItem("token", posRes.access_token);
          this.token = posRes.access_token;
          this.confirmPassword = false;
          this.showProfileForm = true;
        } else {
          this.loading = false;
          const txtmsg = posRes.message;
          const txtmsg1 = this.translateService.instant(txtmsg);
          this.openSnackBar(txtmsg1, '');;
        }
      },
      (err) => {
        this.loading = false;
      }
    );
  }
}
